/* eslint-disable no-underscore-dangle */
// eslint-disable-next-line import/named
import { API_EVENTS, STAFF_MEMBER_EVENTS } from '../constants/actionTypes';

export const initialState = {
  loading: false,
  modal: false,
  data: null,
  error: null,
};

const staffMemberReducer = (state, { type, payload }) => {
  switch (type) {
    case API_EVENTS.REQUEST:
    case STAFF_MEMBER_EVENTS.REMOVE_REQUEST:
      return { ...state, loading: true };

    case API_EVENTS.FAIL:
    case STAFF_MEMBER_EVENTS.REMOVE_FAIL:
      return { ...state, loading: false, error: payload };

    case API_EVENTS.SUCCESS:
      return { ...state, loading: false, data: payload };

    case STAFF_MEMBER_EVENTS.REMOVE_SUCCESS:
      return { ...state, loading: false, data: payload };
    case STAFF_MEMBER_EVENTS.DELETE_SUCCESS:
      // case STAFF_MEMBER_EVENTS.REMOVE_SUCCESS:
      return { ...state, loading: false, data: { ...state.data, ...payload } };

    case STAFF_MEMBER_EVENTS.SET:
      return { ...state, ...payload };

    default:
      return state;
  }
};

export default staffMemberReducer;
